<div class="saveNameList" [ngClass]="{'high': withItems}">
    <div class="header">
        <img src="/assets/images/save-list.svg">
        <p *ngIf="isSavedList && !isCreate" translate>questionBoard.edit.list-popup.saveList</p>
        <p *ngIf="isSavedList && isCreate" translate>questionBoard.edit.list-popup.createList</p>
        <p *ngIf="isDuplicateQuestionnairePopup" translate>questionBoard.edit.duplicate-popup.duplicateQuestionnaire</p>
        <p *ngIf="isDuplicateListPopup" translate>questionBoard.edit.duplicate-popup.duplicateList</p>
        <p *ngIf="isCreateCollectionQuestionPopup" translate>questionBoard.edit.duplicate-popup.create-collection</p>
    </div>
    <div class="contain" [ngClass]="{'show-error':showMaxLengthError}">
        <p *ngIf="isSavedList" translate>questionBoard.edit.list-popup.name</p>
        <p *ngIf="isDuplicateQuestionnairePopup" translate>questionBoard.edit.duplicate-popup.name</p>
        <p *ngIf="isDuplicateListPopup" translate>questionBoard.edit.duplicate-popup.listName</p>
        <p *ngIf="isCreateCollectionQuestionPopup" translate>questionBoard.edit.duplicate-popup.question-name</p>
        <input *ngIf="isSavedList" [formControl]="listForm.controls.name">
        <input *ngIf="isDuplicateQuestionnairePopup || isCreateCollectionQuestionPopup" [formControl]="questionnaireName">
        <input *ngIf="isDuplicateListPopup" [formControl]="listName">
        <div class="tooltip top">
            <div class="warp">
                <p translate>showMaxLengthError70</p>
            </div>
        </div>
    </div>
    <div class="wrap-list" *ngIf="withItems">
        <p translate>questionBoard.edit.list-popup.list</p>
        <div class="list">
            <que-generic-form-array #generic [formControl]="listForm.controls.answerOptionItem"
                [itemTemplate]="itemTemplate"
                [addDefaultItem]="newItem()"
               >
                <ng-template #itemTemplate let-item="control" let-i="index">
                    <que-answer-option-item-input [formControl]="item" [isUsed]="editList?.isUsed"
                        (deleteEvent)="generic.remove(i)" (addEvent)="setNewId(i);generic.add(i)" [fromPopup]="true" [isNew]="newItemIndex==i">
                    </que-answer-option-item-input>
                </ng-template>
              
            </que-generic-form-array>
           
        </div>
            <div class="pointer addOp right" translate (click)="generic.add()">
                <img src="/assets/images/options/add-option.svg">
                questionBoard.edit.add-option
            </div>
            
        <p *ngIf="editList?.isUsed" class="warning" translate>questionBoard.edit.list-popup.inUseWarning</p>
    </div>

    <div class="footer">
        <div class="btn cancel pointer" (click)="cancel()" translate>questionBoard.edit.list-popup.cancel</div>
        <div [ngClass]="{'disable':!isEnableSave() }" *ngIf="(((listForm.controls.name.value!=undefined) && (listForm.controls.name.value!='')) || ((questionnaireName.value!=undefined) && (questionnaireName.value!=''))) ;else disableBtn"
            class="btn save pointer" (click)="isEnableSave()?save():null" >
            <p *ngIf="!isCreate" translate>  questionBoard.edit.list-popup.save </p>
            <p *ngIf="isCreate" translate>  questionBoard.edit.list-popup.create </p>
        </div>
    </div>
</div>

<ng-template #disableBtn>
    <div *ngIf="!isCreate" class="btn save disable" translate>questionBoard.edit.list-popup.save</div>
    <div *ngIf="isCreate" class="btn save disable" translate>questionBoard.edit.list-popup.create</div>
</ng-template>